// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 745 ? "posthog" : chunkId) + "." + {"266":"38edc46e","578":"7a33bd11","584":"e1e9b57e","595":"c5d8c2ef","602":"52d63774","693":"a59db47f","745":"ab7d0a47"}[chunkId] + ".chunk.js";
};